export default __webpack_public_path__ + "static/media/contatoTitle.b3662905.png";